import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './scss/styles.scss'
import * as Sentry from '@sentry/vue'
import 'bootstrap/js/dist/modal'

declare global {
  interface Window {
    dataLayer: any[]
    grecaptcha: any
  }
}

const app = createApp(App)

Sentry.init({
  environment: import.meta.env.MODE,
  app,
  dsn: 'https://e780e69378dc1b2b093e3f7f61cceb16@o4508121914212352.ingest.de.sentry.io/4508371062489168',
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.browserProfilingIntegration(),
  ],
  tracesSampleRate: 0.2,
  profilesSampleRate: 1.0,
})

app.use(router)
app.use(i18n)

app.mount('#app')
